import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Modal from 'react-modal';
import ReportVehicles from './ReportVehicles';
import LoadingSpinner from '../../components/LoadingSpinner/loadingSpinner';

const ReportVehiclesPopup = ({ vehicle_ids: initialVehicleIds, department_id: initialDepartmentId, dealership: initialDealership }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [vehicle_ids, setVehicleIds] = useState(initialVehicleIds || []);
  const [department_id, setDepartmentId] = useState(initialDepartmentId);
  const [dealership, setDealership] = useState(initialDealership);
  const [loading, setLoading] = useState(false);
  const report_vehicles = useSelector(state => state.settings_reports.report_vehicles || []);

  useEffect(() => {
    console.log('ReportVehiclesPopup: Updating props:', { initialVehicleIds, initialDepartmentId, initialDealership });
    setVehicleIds(initialVehicleIds || []);
    setDepartmentId(initialDepartmentId);
    setDealership(initialDealership);
  }, [initialVehicleIds, initialDepartmentId, initialDealership]);

  const openModal = (newVehicleIds, newDepartmentId, newDealership) => {
    console.log('ReportVehiclesPopup: Opening modal with:', { newVehicleIds, newDepartmentId, newDealership });
    setVehicleIds(newVehicleIds || []);
    setDepartmentId(newDepartmentId);
    setDealership(newDealership);
    setLoading(true);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    console.log('ReportVehiclesPopup: Closing modal');
    setModalIsOpen(false);
    setLoading(false);
  };

  // Filter report_vehicles by vehicle_ids
  const filteredVehicles = useMemo(() => {
    console.log('ReportVehiclesPopup: Raw report_vehicles:', { report_vehicles, length: report_vehicles?.length });
    if (!Array.isArray(report_vehicles)) {
      console.warn('ReportVehiclesPopup: report_vehicles is not an array:', { report_vehicles });
      setLoading(false);
      return [];
    }
    const vehicles = report_vehicles.filter(vehicle => 
      vehicle_ids.includes(vehicle.id) && 
      vehicle.dealership === dealership &&
      (vehicle.completed_departments?.some(dept => parseInt(dept.department_id) === parseInt(department_id)) ||
       vehicle.completed_data_steps?.some(dept => parseInt(dept.department_id) === parseInt(department_id)))
    );
    console.log('ReportVehiclesPopup: Filtered vehicles:', { vehicle_ids, department_id, dealership, filteredVehicles });
    setLoading(false);
    return vehicles;
  }, [report_vehicles, vehicle_ids, department_id, dealership]);

  return (
    <div className="col-md-3">
      <div className="btn-group">
        <button
          className="btn btn-sm btn-success"
          onClick={() => {
            console.log('ReportVehiclesPopup: Button clicked:', { vehicle_ids, department_id, dealership });
            openModal(vehicle_ids, department_id, dealership);
          }}
          disabled={loading}
        >
          <i className="fal fa-car" />
        </button>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={() => console.log('ReportVehiclesPopup: Modal opened')}
        onRequestClose={closeModal}
        contentLabel="Department Vehicles"
        className="customModal"
        ariaHideApp={false}
        overlayClassName="report-overlay"
      >
        <div className="customCard">
          <div className="customHeader">
            <button
              type="button"
              className="btn btn-danger btn-sm float-end space-left-2"
              aria-label="Close"
              onClick={closeModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="customContent">
            {loading ? (
              <div className="text-center" style={{ padding: '20px', fontSize: '1rem', color: '#666' }}>
                <LoadingSpinner loading />
              </div>
            ) : filteredVehicles.length === 0 ? (
              <div className="text-center" style={{ padding: '20px', fontSize: '1rem', color: '#666' }}>
                <LoadingSpinner loading />
              </div>
            ) : (
              <ReportVehicles
                report_id={null}
                department_id={department_id}
                work_flow_id={department_id}
                vehicles={filteredVehicles}
              />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ReportVehiclesPopup;